import React, { Fragment, useEffect, useState, useContext } from 'react';
import SidebarMenu from './SidebarMenu';
import CustomizerContext from '../../_helper/Customizer';
import { SidebarCollapseContext } from '../Layout';

const SideBarLayout = (props) => {

  const { toggleIcon } = useContext(CustomizerContext);
  const { toggle: toggleCollapse } = useContext(SidebarCollapseContext);
  const [currentUrl] = useState(window.location.pathname);
  const [menuItems, setMenuItems] = useState([]);

  const id = window.location.pathname.split('/').pop();
  // eslint-disable-next-line
  const [leftArrow, setLeftArrow] = useState(false);
  const layout = id;
  const [width, setWidth] = useState(0);
  const handleResize = () => {
    setWidth(window.innerWidth - 500);
  };// eslint-disable-next-line
  const [mainmenu, setMainMenu] = useState([]);
  const handleScroll = () => {
    if (window.scrollY > 400) {
      document.querySelector('.main-navbar').className =
        'main-navbar hovered';
    } else {
      if (document.getElementById('main-navbar'))
        document.querySelector('.main-navbar').className = 'main-navbar';
    }
  };

  const setNavActive = (item) => {
    menuItems.map(menuItems => {
      menuItems.Items.filter(Items => {
        if (Items !== item) {
          Items.active = false;
          document.getElementById('bg-overlay1').classList.remove('active');
        }
        if (Items.children && Items.children.includes(item)) {
          Items.active = true;
        }
        if (Items.children) {
          Items.children.filter(submenuItems => {
            if (submenuItems.children && submenuItems.children.includes(item)) {
              Items.active = true;
              submenuItems.active = true;
              return true;
            } else {
              return false;
            }
          });
        }
        return Items;
      });
      return menuItems;
    });
    item.active = !item.active;
    setMainMenu({ mainmenu: menuItems });
  };
  useEffect(() => {
    setLeftArrow(true);
    window.addEventListener('resize', handleResize);
    handleResize();
    const currentUrl = window.location.pathname;
    menuItems.map(items => {
      items.Items.filter((Items) => {
        if (Items.path === currentUrl)
          setNavActive(Items);
        if (!Items.children) return false;
        Items.children.filter(subItems => {
          if (subItems.path === currentUrl)
            setNavActive(subItems);
          if (!subItems.children) return false;
          subItems.children.filter(subSubItems => {
            if (subSubItems.path === currentUrl) {
              setNavActive(subSubItems);
              return true;
            } else {
              return false;
            }
          });
          return subItems;
        });
        return Items;
      });
      return items;
    });
    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    };
    // eslint-disable-next-line
  }, [layout, currentUrl]);

  const closeOverlay = () => {
    document.getElementById('bg-overlay1').classList.remove('active');
    const sidebar = document.querySelector('header.main-nav');
    if (sidebar && window.innerWidth <= 991) {
      sidebar.classList.add('close_icon');
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (window.innerWidth <= 991) {
        const sidebar = document.querySelector('header.main-nav');
        const hamburger = document.querySelector('.mobile-toggle');

        if (sidebar && !sidebar.classList.contains('close_icon') &&
            !sidebar.contains(event.target) &&
            !hamburger?.contains(event.target)) {
          sidebar.classList.add('close_icon');
          document.getElementById('bg-overlay1').classList.remove('active');
        }
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  return (
    <Fragment>
      <div id="bg-overlay1" onClick={() => {
        closeOverlay();
      }} ></div>
      {/* Show sidebar button — only visible when collapsed on desktop */}
      <div className="d-none d-lg-flex sidebar-show-toggle"
          onClick={toggleCollapse}
          title="Show sidebar">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="13 17 18 12 13 7"/>
            <polyline points="6 17 11 12 6 7"/>
        </svg>
      </div>
      <header className={`main-nav ${toggleIcon ? 'close_icon' : ''}`}>
        {/*<Profile />*/}
        { // We want to show which partner a user is logged in as so we will conditionally show that here using local storage
          localStorage.getItem('partnerName') && localStorage.getItem('accessLevel') === 'partner' ?
              <center><div id='sidebar-header-text-div' className='mt-4'><p style={{ fontSize:17, color:'#9c9b9a', marginTop: 38, lineHeight: 1.5 }}><strong>{localStorage.getItem('partnerName')}</strong></p></div></center>
              : null
        }
        <SidebarMenu setMainMenu={setMainMenu} setParentMenuItems={setMenuItems} props={props} sidebartoogle={true} setNavActive={setNavActive} width={width} />
        {/* Desktop collapse toggle — pill tab on the sidebar's right edge */}
        <div className="d-none d-lg-flex sidebar-collapse-toggle" onClick={toggleCollapse}
            title="Hide sidebar">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="11 17 6 12 11 7"/>
                <polyline points="18 17 13 12 18 7"/>
            </svg>
        </div>
      </header>
    </Fragment>
  );
};
export default SideBarLayout;